import React, { } from "react";
import { Form, Col } from 'react-bootstrap';
import { useDispatch } from 'redux-react-hook';

export default function SettingOpenLimit(props) {
    const questionIndex = props.index;
    const data = props.data || { max: 3, min: 1 };
    const MIN_MIN = 1, MAX_MIN = 1;
    const min = null != data.min && false == isNaN(data.min) ? data.min : -1;
    const max = null != data.max && false == isNaN(data.max) ? data.max : -1;
    const dispatch = useDispatch();
    // console.log(props);

    function onChangeMin(e) {
        try {
            let tmp = parseInt(e.target.value);
            if (tmp < MIN_MIN) tmp = MIN_MIN;
            // console.log(tmp, e.target.value, MIN_MIN);
            dispatch({
                type: "QUESTION_SET_OPEN_LIMIT",
                index: questionIndex,
                data: {
                    ...data,
                    min: tmp
                }
            });
        } catch (e) {

        }
    }
    function onChangeMax(e) {
        try {
            let tmp = parseInt(e.target.value);
            if (tmp < MAX_MIN) tmp = MAX_MIN;
            // console.log(tmp, e.target.value, MAX_MIN);
            dispatch({
                type: "QUESTION_SET_OPEN_LIMIT",
                index: questionIndex,
                data: {
                    ...data,
                    max: tmp
                }
            });
        } catch (e) {

        }
    }

    function render() {
        // console.log(min, max);
        return (
            <Form.Group>
                <Form>
                    <Form.Row>
                        <Form.Label column xs="2">長度</Form.Label>
                        <Col className="text-left">
                            <Form.Control onChange={onChangeMin} type="number" value={min} />
                        </Col>
                        <Form.Label column xs="4" className="text-muted" style={{ fontSize: "80%" }}>(至少可寫多少字元)</Form.Label>
                    </Form.Row>
                    <Form.Row>
                        <Form.Label column xs="2"></Form.Label>
                        <Col className="text-left">
                            <Form.Control onChange={onChangeMax} type="number" value={max} />
                        </Col>
                        <Form.Label column xs="4" className="text-muted" style={{ fontSize: "80%" }}>(至多可寫多少字元)</Form.Label>
                    </Form.Row>
                </Form>
            </Form.Group>
        );
    }

    return render();
}
